<template>
  <b-container fluid>
    <RpmClassificationList/>
  </b-container>
</template>

<script>
import RpmClassificationList from './List';

export default {
  name: 'RpmClassificationIndex',
  components: { RpmClassificationList },
};
</script>
